module.exports = __webpack_public_path__ + "img/3.5961ef68.svg";